module.exports = __webpack_public_path__ + "static/media/freshworks.d1699840.png";